<template>
    <div class="card height-100">
      <div class="card-content">
        <p class="has-text-weight-bold" v-if="demandeLogistique.ligneCommande">
          {{ $t('gestionAffectation.informationCommande.title',
          { codeCommande: demandeLogistique.ligneCommande.codeCommande,
            annonceur: getAnnonceur }) }}
        </p>
        <p class="has-text-weight-bold" v-if="demandeLogistique.produit">
          {{ $t('gestionAffectation.informationProduit.title') }}
        </p>
        <p class="has-text-weight-bold mgt-10px">
           {{ $t('gestionAffectation.informationCommande.actionLogistique',
              { action: demandeLogistique.actionLogistique})}}
        </p>
        <div class="mgt-10px level" v-if="demandeLogistique.ligneCommande">
          <div class="level-left has-text-default is-size-7">
              {{ $t('gestionAffectation.informationCommande.theme',
          { theme: demandeLogistique.ligneCommande.theme }) }}
          </div>
          <div class="level-right">
            <router-link-blank
              :to="{ name: 'c.bodac.commandes',
              params: { id: demandeLogistique.ligneCommande.devisCommandeId } }"
              :message="$t('gestionAffectation.informationCommande.plusdinfo')"
              classComposant="is-underline lien">
            </router-link-blank>
            <router-link-blank class="mgl-10px"
              :to="{ name: 'c.bodac.commandes',
              params: { id: demandeLogistique.ligneCommande.devisCommandeId} }" icon="open-in-new"
              sizeIcon="is-small"
              classComposant="is-underline lien">
            </router-link-blank>
          </div>
        </div>
        <div class="mgt-10px level" v-if="demandeLogistique.produitId">
          <div class="level-left has-text-default is-size-7">
              {{ $t('gestionAffectation.informationProduit.date',
            { date: formatDate(demandeLogistique.datePlanification) }) }}
          </div>
          <div class="level-right">
            <router-link-blank
              :to="{ name: getLibelleAndRoutesForProduct(demandeLogistique).routeDetail,
              params: { id: demandeLogistique.produitId } }"
              :message="$t('gestionAffectation.informationProduit.plusdinfo')"
              classComposant="is-underline lien">
            </router-link-blank>
            <router-link-blank class="mgl-10px"
              :to="{ name: getLibelleAndRoutesForProduct(demandeLogistique).routeDetail,
              params: { id: demandeLogistique.produitId} }" icon="open-in-new"
              sizeIcon="is-small"
              classComposant="is-underline lien">
            </router-link-blank>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import * as produitConf from '@/configuration/catalogue/produitConf';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'informationCommande',
  props: {
    demandeLogistique: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getAnnonceur() {
      if (!this.demandeLogistique.ligneCommande) return '';
      return this.demandeLogistique.ligneCommande.annonceurs;
    },
  },
  methods: {
    getLibelleAndRoutesForProduct(demande) {
      const produitConfiguration = produitConf.CATEGORIE_PRODUIT.find(
        (produitObject) => {
          return produitObject.code === demande.typeProduit;
        },
      );
      return produitConfiguration;
    },
    formatDate(date) {
      return formatDate(date);
    },
  },
  components: {
    RouterLinkBlank,
  },
};
</script>

<style scoped>

</style>
